import type { ChangeEventHandler, FC, MouseEvent } from 'react'
import React from 'react'

import cs from 'classnames'

import { capitalize } from '../../utilities/misc/capitalize'
import type { ProductColour } from './ColourSwatchGroup'
import styles from './ColourSwatchGroup.module.scss'

export const ColourSwatch: FC<ColourSwatchProps> = ({ name, value, checked, onChange }) => {
  const primaryColour = value[0]
  const secondaryColour = value[1] || null
  const formattedPrimaryColour = capitalize(primaryColour).replace(/_/g, ' ')
  const primaryColourClass = `circle-${primaryColour}`
  const secondaryColourClass = `semicircle-${secondaryColour}`
  const label = secondaryColour
    ? `${formattedPrimaryColour} with ${secondaryColour.replace(/_/g, ' ')}`
    : formattedPrimaryColour

  return (
    <div
      className={styles.container}
      onClick={(e: MouseEvent<HTMLInputElement>) => e.stopPropagation()}
    >
      <input
        id={`${name}${primaryColour}${secondaryColour}`}
        name={name}
        type="radio"
        className={styles.swatchRadio}
        checked={checked}
        onChange={onChange}
        value={value}
        aria-label={label}
      />
      <label
        htmlFor={`${name}${primaryColour}${secondaryColour}`}
        data-testid="label"
        className={cs(
          styles.circle,
          styles[primaryColourClass],
          secondaryColour && styles[secondaryColourClass],
          secondaryColour && styles.secondaryColour
        )}
        title={label}
      />
    </div>
  )
}

interface ColourSwatchProps {
  name: string
  value: ProductColour[]
  checked: boolean
  onChange: ChangeEventHandler<HTMLInputElement>
}
